const PageRedirectionHandler = (pageUrl: string) => {
  let activePage = false;
  if (pageUrl !== "/") {
    if (
      typeof window !== "undefined" &&
      window.location.pathname.startsWith(pageUrl)
    ) {
      activePage = true;
    }
  } else {
    if (
      typeof window !== "undefined" &&
      window.location.pathname === `${pageUrl}`
    ) {
      activePage = true;
    }
  }
  return activePage;
};

export default PageRedirectionHandler;
